export default __webpack_public_path__ + "static/media/Settings Tutorial.8f47639f.mp4";